export default {
  messageType: 'Carousel Commerce',
  carouselSetting: 'Carousel Settings',
  title: 'Carousel Commerce Settings',
  label: {
    introSetting: 'Intro settings',
    attachIntroImage: 'Attached is the intro image',
    introTitle: 'The title of the intro',
    introContent: 'The intro',
    introMobileWebLink: 'Intro Mobile Web Link',
    introPcWebLink: 'Intro PC Web Link',
    introIosDeepLink: 'Intro iOS App Link',
    introAndroidDeepLink: 'Intro Android App Link',
    image: 'Image',
    title: 'Product name',
    regularPrice: 'Regular Price',
    discountPrice: 'Discount Price',
    discountRate: 'Discount Rate',
    discountFixed: 'Fixed Discount Price',
    additionalContent: 'Additional Information',
    imageLink: 'Image Link',
  },
  placeholder: {
    price: '0 ~ 99,999,999',
    rate: '0 ~ 100',
    fixed: '0 ~ 999,999',
    imageLink: 'Clicking the image will redirect to the registered link.',
  },
  alt: {
    image: 'Carousel Commerce Image {count}',
  },
  comment: {
    image: 'Recommended: 800x400 (2:1), 800x800 (1:1), 800x600 (4:3) / Max 5MB. Carousel images must have the same aspect ratio.',
    price: 'Either the discount rate or the fixed discount price must be entered.',
  },
  validation: {
    list: {
      max: 'A maximum of 6 carousels can be added.',
      introMax: 'If an intro is included, a maximum of 5 carousels can be added.',
      min: 'If an intro is included, at least one carousel is required.',
      introMin: 'At least two carousels are required.',
    },
  },
};
